import { render, staticRenderFns } from "./heart-tap.vue?vue&type=template&id=67d16bf4&scoped=true&"
import script from "./heart-tap.vue?vue&type=script&lang=js&"
export * from "./heart-tap.vue?vue&type=script&lang=js&"
import style0 from "./heart-tap.vue?vue&type=style&index=0&id=67d16bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d16bf4",
  null
  
)

export default component.exports